import { useCallback, useLayoutEffect, useRef } from "react";
export const useStableCallback = (fn) => {
    const ref = useRef(fn);
    useLayoutEffect(() => {
        ref.current = fn;
    }, [fn]);
    return useCallback((...args) => ref.current(...args), [ref]);
};
//# sourceMappingURL=useStableCallback.js.map